export default __webpack_public_path__ + "static/media/01.77a204ee.jpg";